/**
 * 
 * @param {number} amount - Amount to display
 * @param {any} currencyInfo - CurrencyInfo object
 * @param {number} [minimumFractionDigits="2"]
 * @param {number} [maximumFractionDigits="2"]
 * @returns {string} Returns price amount with the currency symbol
 */
const buildVisiblePrice = function (amount, currencyInfo, minimumFractionDigits, maximumFractionDigits) {
    var opts = {
        style: 'currency', currency: currencyInfo.code, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2, maximumFractionDigits: 2 };
    if (typeof minimumFractionDigits !== 'undefined') opts.minimumFractionDigits = minimumFractionDigits;
    if (typeof maximumFractionDigits !== 'undefined') opts.maximumFractionDigits = maximumFractionDigits;

    if (typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function') {
        return new Intl.NumberFormat(currentLanguageCode, opts).format(amount);
    }
    else {
        var result = '';
        if (currencyInfo.symbolBeforeSum) {
            result = currencyInfo.spaceBetweenSumAndSymbol ? currencyInfo.symbol + '\xa0' + amount.toFixed(opts.minimumFractionDigits) : currencyInfo.symbol + amount.toFixed(opts.minimumFractionDigits);
        }
        else {
            result = currencyInfo.spaceBetweenSumAndSymbol ? amount.toFixed(opts.minimumFractionDigits) + '\xa0' + currencyInfo.symbol : amount.toFixed(opts.minimumFractionDigits) + currencyInfo.symbol;
        }
        return result;
    }
};

export { buildVisiblePrice };